import { connect } from 'react-redux';
import { uiState } from 'react-redux-ui-state';

import MissionCtrl from './MissionCtrl';
import { selectors as userSelectors } from '../../dux/user';
import { selectors as orgSelectors } from '../../dux/org';
import getBannerNotificationsState from '../../dux/notifications/selectors';

const mapStateToProps = (state) => ({
  isAuthenticated: userSelectors.isAuthenticated(state),
  user: userSelectors.getIdentityState(state),
  isAdmin: userSelectors.isAdmin(state),
  isORv4Admin: userSelectors.isORv4Admin(state),
  org: orgSelectors.getOrgState(state),
  ...getBannerNotificationsState(state),
});

const uiConfig = {
  persist: true,
  name: 'nav',
  state: () => ({
    open: false,
  }),
};

export default uiState(uiConfig)(connect(mapStateToProps, null)(MissionCtrl));
